import styled from 'styled-components'

import LinkWithFallback from '../../../../../../app/_components/navigation/LinkWithFallback'

export const DisplayTextWrapper = styled.div<{
  $flex: boolean
  $fullWidth: boolean
}>`
  ${({ $flex, $fullWidth }) =>
    $flex &&
    `
    display: flex;
    justify-content: space-between;
    width: ${$fullWidth ? '100%' : 'intial'}
  `}
`

// TODO: Leverage TextLink instead of manually creating these styles again.
export const ColorLink = styled(LinkWithFallback)<{
  $flexStart: boolean
}>`
  text-decoration: underline;
  font-weight: 600;
  color: ${o => o.theme.color.text.tertiary.on.background};
  justify-self: ${o => (o.$flexStart ? 'flex-start' : 'flex-end')};
  display: flex;

  &:hover {
    color: ${o => o.theme.color.text.secondary.on.background};
  }
`
